import React from 'react'
// import {Redirect} from 'react-router-dom'
// import PageAboutBakery from './container/AboutBakery/PageAboutBakery'
// import Home from './container/Home/Home'


const PageAboutBakery = React.lazy(() => import('./container/AboutBakery/PageAboutBakery')) 
const PrincipalMenu = React.lazy(() => import('./container/Menu/PrincipalMenu'))
const GalleryPage = React.lazy(() => import('./container/Gallery/GalleryPage'))
// const redirectRoute = [
//     {
//         path: '/',
//         exact: true,
//         component: () => <Redirect to="/dashboard/default" />,
//     },
// ]

// const errorRoute = [
//     {
//         component: () => <Redirect to="/session/404" />,
//     },
// ]

const pageRoutes = [
   
    {
        path: '/about',
        // component: React.lazy(() => import('./container/AboutBakery/PageAboutBakery')),
        component: <PageAboutBakery />,
    },
    {
        
        path: '/menu',
        component: <PrincipalMenu />, 
    },
    {
        
        path: '/gallery',
        component: <GalleryPage />, 
    }
    
]

const routes = [
    ...pageRoutes
]

export default routes